import React from "react";
import { Link } from "react-router-dom";
import "../css/Facilite.css";

const Facilitie = () => {
  const facilityImg = "./images/ss.jpeg";

  return (
    <>
      <section className="facilities-container">
        <div className="fac-main-card">
          <div className="fac-flex-layout">
            {}
            <div className="fac-image-box">
              <img
                src={facilityImg}
                alt="School Facilities"
                className="fac-hero-img"
              />
            </div>

            {}
            <div className="fac-info-box">
              <div className="fac-green-header">
                <h2>Facilities</h2>
              </div>

              <div className="fac-content-body">
                <p className="fac-desc-text">
                  Sahara Public School offers world-class facilities that
                  provide students with a safe, modern and inspiring learning
                  environment. Our campus includes smart classrooms, fully
                  equipped science and computer laboratories, a well-stocked
                  library, sports arenas, activity rooms, music and dance
                  studios, transport services and secure infrastructure. Every
                  facility is thoughtfully designed to support academic
                  excellence, creativity, innovation and the holistic
                  development of every child.
                </p>

               <Link
  to="/facilitiespage"
  className="btn btn-primary"
>
  READ MORE <i>›</i>
</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Facilitie;
